<script>
    export default {
        props: {
            if: {
                required: false,
            },
            to: {
                type: Object,
                required: true,
            },
        },
        render(h) {
            // Just return default slot if 'if' is false
            if(!this.if) {
                return this.$slots.default[0]
            }

            // Return router link
            return h('router-link', {
                props: {
                    to: this.to
                }
            }, this.$slots.default)
        }
    }
</script>
